import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MiniCartComponent } from "./mini-cart.component";

@NgModule ({
    
    declarations: [
        MiniCartComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        MiniCartComponent
    ]

})

export class MiniCartModule { };